const MusicIcon = (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2663 11.2931C14.2663 11.2931 16.2012 6.46061 13.191 3.53218C12.9533 4.38291 12.5387 5.17392 11.9745 5.85354C11.4102 6.53316 10.7089 7.0861 9.91639 7.47625C8.14837 8.46238 4.71949 10.7975 4.07356 13.9363C3.77406 15.2731 3.85406 16.6669 4.30455 17.9606C4.75504 19.2542 5.55809 20.3963 6.62309 21.2579C6.7962 20.6625 7.08642 20.1076 7.47672 19.6258C7.86703 19.144 8.34957 18.745 8.89608 18.4521C9.35235 18.2355 9.76093 17.9303 10.098 17.5542C10.4351 17.1781 10.6939 16.7386 10.8593 16.2614C11.7651 17.026 12.4569 18.0125 12.8672 19.1246C13.2774 20.2367 13.392 21.4362 13.1997 22.6058L13.1965 22.6207C14.4361 22.3473 15.5758 21.7363 16.4897 20.8552C17.4036 19.9742 18.0559 18.8575 18.3745 17.6288C19.2561 14.7394 18.5073 10.3905 17.3592 8.77417C16.5592 9.86316 15.4947 10.7301 14.2663 11.2931Z"
      fill="#FFC37C"
    />
  </svg>
);
export default MusicIcon;
